import { useNavigate, Link } from "react-router-dom";
import { DeleteIcon, EditIcon } from "../../assets/icons/Svgs";
import { eliminarIdioma } from "../../services/idioma.service";
import {
  showDeletedAlert,
  showErrorAlert,
  showQuestionDeleteAlert,
  showUpdateAlert,
} from "../../components/molecules/ShowAlert";

export const IdiomaCard = ({ idioma = {}, index, onDelete }) => {
  const navigate = useNavigate();

  const handleDelete = async () => {
    showQuestionDeleteAlert({
      callback: async (result) => {
        if (result.isConfirmed) {
          try {
            await eliminarIdioma(idioma.idIdioma);
            showDeletedAlert({
              callback: () => onDelete?.(idioma.idIdioma),
            });
          } catch (error) {
            console.error("Error al eliminar el idioma:", error);
            showErrorAlert();
          }
        }
      },
    });
  };

  const handleUpdate = () => {
    showUpdateAlert({
      callback: () => navigate(`/idiomas/actualizar/${idioma.idIdioma}`),
    });
  };

  return (
    <tr className="bg-white hover:bg-gray-100 transition-colors duration-300 [&>td]:p-3 text-sm [&>td]:text-gray-700 border-gray-200">
      <td className="font-medium border-r border-slate-200 border-t">{index}</td>
      <td className="border-r border-slate-200 border-t">{idioma.sigla}</td>
      <td className="border-r border-slate-200 border-t">{idioma.nombre}</td>
      <td className="border-slate-200 border-t">
        <div className="flex flex-wrap justify-evenly items-center gap-2">
          <Link
            to={`/idiomas/modulos/${idioma.idIdioma}`}
            className="bg-theme-yellow text-white text-sm font-semibold transition-colors hover:bg-yellow-500 py-1 px-3 rounded shadow"
          >
            Ver módulos
          </Link>

          <button
            onClick={handleUpdate}
            className="bg-green-500 hover:bg-green-600 p-1 rounded text-white"
            title="Editar"
          >
            <EditIcon className="w-5 h-5" />
          </button>

          <button
            onClick={handleDelete}
            className="bg-red-500 hover:bg-red-600 p-1 rounded text-white"
            title="Eliminar"
          >
            <DeleteIcon className="w-5 h-5" />
          </button>
        </div>
      </td>
    </tr>
  );
};
